type RoleMetadataLike = {
    name: string;
    roleKey?: string | null;
    isSystem?: boolean;
    isEditable?: boolean;
};

const LOCKED_SYSTEM_ROLE_METADATA_KEYS = new Set(['OWNER']);

const normalizeRoleMetadataKey = (value: string | null | undefined) => (
    String(value || '').trim().toUpperCase()
);

const getRoleMetadataIdentityKey = (role: RoleMetadataLike) => (
    normalizeRoleMetadataKey(role.roleKey || (role.isSystem ? role.name : ''))
);

export const isRoleMetadataLocked = (role: RoleMetadataLike) => (
    Boolean(role.isSystem) && LOCKED_SYSTEM_ROLE_METADATA_KEYS.has(getRoleMetadataIdentityKey(role))
);

export const canEditRoleMetadata = (role: RoleMetadataLike) => (
    Boolean(role.isEditable) && !isRoleMetadataLocked(role)
);
